import { ref, onMounted, onBeforeUnmount } from '@vue/composition-api'

export default function useToggleSidebarShortcut() {
  const wasCtrlBPressed = ref(false)

  const handleKeyDown = event => {
    if (event.ctrlKey && event.key === 'b') {
      wasCtrlBPressed.value = !wasCtrlBPressed.value
    }
  }

  onMounted(() => {
    window.addEventListener('keydown', handleKeyDown)
  })

  onBeforeUnmount(() => {
    window.removeEventListener('keydown', handleKeyDown)
  })

  return {
    wasCtrlBPressed,
  }
}
